import { Form as FinalForm, Field } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import { Grid, Typography } from '@mui/material'
import useTextEditor from './hooks/useTextEditor'
import Button from '../control/Button'
import TextEditorInput from '../component/input/TextEditorInput'

const TextEditorPlayground = () => {
    const { onSubmit } = useTextEditor()
    const { t } = useTranslation()

    return (
        <Grid container>
            <Grid container>
                <Typography variant="h3" gutterBottom>
                    Control: Text Editor
                </Typography>
            </Grid>
            <Grid container>
                <FinalForm onSubmit={onSubmit}>
                    {({ handleSubmit }) => (
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Field
                                        name="textEditor"
                                        label="Text Editor"
                                        placeholder={t('LABEL.TEXT_REQUIRED')}
                                        component={TextEditorInput}
                                        required
                                    />
                                </Grid>
                                <Grid item md={12}>
                                    <Button color="primary" onClick={handleSubmit}>
                                        {t('BUTTON.SAVE')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    )}
                </FinalForm>
            </Grid>
        </Grid>
    )
}

export default TextEditorPlayground
